import { Box, Drawer, MenuItem, Typography, useTheme } from "@mui/material";
import {
  ExportKeyDetailWrapper,
  ExportKeyTextWrapper,
  PasswordButtonGroups,
  PasswordInput,
  ViewPasswordButton,
  WalletAddressContainer,
} from "components/portfolio/styled";
import { CircleButton } from "components/CircleButton";
import { Chain, EVM_CHAINS } from "chainConfigs";
import { StyledExportKeyTextDrawer } from "components/portfolio/styled";
import { CrossChainConfig } from "v2/components/CrossChainDeposit/hocs/withCrossChainDeposit";
import { Close } from "@mui/icons-material";
import { useState } from "react";
import { useEffect, useRef } from "react";
import { RetroButton } from "components/RetroButton";
import { ReactComponent as PrivateIcon } from "assets/icons/private.svg";
import { ReactComponent as ShowIcon } from "assets/icons/eye.svg";
import { ReactComponent as HideIcon } from "assets/icons/eye-slash.svg";
import { Col, Row } from "v2/components/base/Flex/ui";
import Select from "v2/components/base/Select/ui";
import BasicButton from "v2/components/Buttons/BasicButton";
import CloseButton from "v2/components/Buttons/CloseButton";

const ExportPrivateKeyV2 = ({
  isOpen,
  close,
  onCopySuccess,
  sortedConfigs,
  selectedChain,
  setSelectedChain,
  handleCopy,
  keys,
}: {
  defaultChain?: Chain;
  chains: Array<Chain>;
  isOpen: boolean;
  close: () => void;
  onCopySuccess: () => void;
  sortedConfigs: CrossChainConfig[];
  selectedChain: Chain;
  setSelectedChain: (chain: Chain) => void;
  handleCopy: () => void;
  keys: Record<string, string | null>;
}) => {
  const theme = useTheme();

  return (
    <Drawer
      anchor={"bottom"}
      open={isOpen}
      sx={{
        "& .MuiDrawer-paper": {
          width: "100%",
          height: "100%",
          backgroundColor: theme.palette.surface.black,
          color: theme.palette.text.primary,
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
          padding: "24px",
        },
      }}>
      <Col type="cc" sx={{ maxWidth: "1200px" }} fullWidth fullHeight>
        <Box
          sx={{
            marginLeft: "auto",
            fontSize: "16px",
            cursor: "pointer",
          }}>
          <CloseButton onClick={close} />
        </Box>
        <ExportKeyDetailWrapper>
          <Row
            sx={{
              width: "100%",
              maxWidth: "395px",
              marginBottom: "16px",
              textAlign: "center",
            }}>
            <Typography variant="mobile-h1">Your Private Key / Recovery Phrase</Typography>
          </Row>
          <ExportKeyTextWrapper>
            <Typography variant="mobile-body-m" color="text.system-red">
              Never share your private key or recovery phrase to anyone.
            </Typography>
          </ExportKeyTextWrapper>
          <Select
            value={selectedChain}
            onChange={(event: any) => setSelectedChain(event.target.value as Chain)}
            sx={{ width: "100%", maxWidth: "495px", marginBottom: "16px" }}
            options={sortedConfigs.map((option) => ({
              label: option.networkName,
              value: option.id,
            }))}
          />
          <WalletAddressContainer>
            <PasswordInputs
              chain={selectedChain}
              password={EVM_CHAINS.includes(selectedChain) ? keys.ethereum! : keys[selectedChain]!}
            />
          </WalletAddressContainer>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              maxWidth: "495px",
            }}>
            <BasicButton variant="primary" onClick={handleCopy} sx={{ width: "100%" }}>
              <Typography variant="mobile-action-s-heavy">Copy</Typography>
            </BasicButton>
          </Box>
        </ExportKeyDetailWrapper>
      </Col>
    </Drawer>
  );
};

const PasswordInputs = ({ password, chain }: { password: string; chain: Chain }) => {
  const [isShowPassword, setShowPassword] = useState<boolean>(false);
  const passwordRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setShowPassword(false);
  }, [chain]);

  const handleShowPassword = () => {
    setShowPassword(!isShowPassword);
  };

  return (
    <>
      <Box
        sx={{
          position: "relative",
          width: "100%",
        }}>
        <PasswordInput
          type={isShowPassword ? "text" : "password"}
          ref={passwordRef}
          disabled
          value={password}
        />
        <PasswordButtonGroups>
          <ViewPasswordButton
            $variant={isShowPassword ? "text" : "password"}
            onClick={handleShowPassword}>
            {isShowPassword ? (
              <ShowIcon width={16} height={16} />
            ) : (
              <HideIcon width={16} height={16} />
            )}
          </ViewPasswordButton>
        </PasswordButtonGroups>
      </Box>
    </>
  );
};

export { ExportPrivateKeyV2 };
